import type { RegisteredComponent } from "@builder.io/sdk-react";

import { categoryCustomComponents } from "./category";
import { commonCustomComponents } from "./common";
import { footerCustomComponents } from "./footer";
import { layoutCustomComponents } from "./layout";
import { liveChatComponents } from "./liveChat";
import { productCustomComponents } from "./product";
import { softAgeVerificationComponents } from "./softAgeVerification";

export const customComponents: RegisteredComponent[] = [
  ...footerCustomComponents,
  ...layoutCustomComponents,
  ...softAgeVerificationComponents,
  ...liveChatComponents,
  ...productCustomComponents,
  ...categoryCustomComponents,
  ...commonCustomComponents,
];
